import React from 'react';
import { Highlight } from '@fiverr-private/data_display';
import { Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import { Gql } from '@fiverr-private/dynamic_matching';
import type { SellerBriefResponse } from '../../../types/SellerBriefResponse';

const T_NEED_TYPE_PREFIX = 'brief_preview_drawer.person_brief.need_type';

export const NeedTypeTags = ({
  needType,
  needTypeDetails,
}: {
  needType: SellerBriefResponse['needType'];
  needTypeDetails: SellerBriefResponse['needTypeDetails'];
}) => {
  const needTypeCopy: string = needType === Gql.DmBriefNeedType.Ongoing ? 'ongoing' : 'one_time';
  return (
    <Stack direction="row" gap="3" wrap="wrap">
      {needType && (
        <Highlight>
          <I18n k={`${T_NEED_TYPE_PREFIX}.${needTypeCopy}`} />
        </Highlight>
      )}
      {needTypeDetails?.ongoingWorkPotential && (
        <Highlight>
          <I18n k={`${T_NEED_TYPE_PREFIX}.ongoing_work_potential`} />
        </Highlight>
      )}
    </Stack>
  );
};
